<script setup>
defineProps({
  match: {
    type: Number,
    default: 0,
  },
  title: {
    type: String,
    required: true,
  },
})
</script>
<template>
  <div class="flex items-center rounded-3xl bg-gray-200">
    <div
      class="align-center flex w-[45px] justify-center rounded-3xl bg-secondary px-2 py-2 font-sans text-[0.625rem] font-semibold text-white"
    >
      <span>{{ match ? `${match.toFixed()}%` : '-' }}</span>
    </div>
    <div
      class="flex h-4 w-full px-2 font-sans text-[0.625rem] font-semibold uppercase"
    >
      <span>{{ title }}</span>
    </div>
  </div>
</template>
